"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const Channel_1 = tslib_1.__importDefault(require("../enums/Channel"));
class GetNextBestInformationalQueryRequest extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)({ maxDecimalPlaces: 0 }),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(5),
    (0, class_transformer_1.Type)(() => Number),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: 2, description: 'The max number of informationals that should be returned.' }),
    tslib_1.__metadata("design:type", Number)
], GetNextBestInformationalQueryRequest.prototype, "maxInformationals", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: '022a8853-0eff-45a5-b482-96705ad546f0', description: 'Profile ID' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestInformationalQueryRequest.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.Brand)),
    (0, base_models_1.Docs)({ example: base_models_1.Brand.ESSENT, description: 'Brand the promotion is for' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestInformationalQueryRequest.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(Channel_1.default)),
    (0, base_models_1.Docs)({ example: Channel_1.default.MIJN, description: 'Channel the promotion is for' }),
    tslib_1.__metadata("design:type", String)
], GetNextBestInformationalQueryRequest.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.SegmentType), { each: true }),
    (0, class_transformer_1.Expose)({ name: 'segment_types' }),
    (0, base_models_1.Docs)({ example: [base_models_1.SegmentType.SOHO], description: 'Promotion segment types' }),
    tslib_1.__metadata("design:type", Array)
], GetNextBestInformationalQueryRequest.prototype, "segmentTypes", void 0);
exports.default = GetNextBestInformationalQueryRequest;
